import { render } from "./CreateAccount.vue?vue&type=template&id=c605d4e6&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=c605d4e6&scoped=true&lang=css"
import "./CreateAccount.vue?vue&type=style&index=1&id=c605d4e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c605d4e6"]])

export default __exports__